// gatsby-browser.js
import React from "react";
import MsalProviderWrapper from "./src/MsalProviderWrapper";

export const wrapRootElement = ({ element }) => (
  <MsalProviderWrapper>{element}</MsalProviderWrapper>
);
